import { hexToDecimalSRGB, luminance } from './luminance.js';
function typedColor(color, string) {
    if (!string) {
        if (typeof color === 'string')
            return hexToDecimalSRGB(color);
        else
            return color;
    }
    else {
        if (typeof color === 'string')
            return color;
        else
            throw new Error(`Invalid arguments to typedColor`);
    }
}
export function contrastColor(color, { light = '#ffffff', dark = '#000000', threshold = 0.5, } = {}) {
    if (luminance(color) >= threshold) {
        return typedColor(dark, typeof color === 'string');
    }
    else {
        return typedColor(light, typeof color === 'string');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udHJhc3RDb2xvci5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjb250cmFzdENvbG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxTQUFTLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQVc1RCxTQUFTLFVBQVUsQ0FDbEIsS0FBd0MsRUFDeEMsTUFBZTtJQUVmLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUNiLElBQUksT0FBTyxLQUFLLEtBQUssUUFBUTtZQUFFLE9BQU8sZ0JBQWdCLENBQUMsS0FBSyxDQUFDLENBQUE7O1lBQ3hELE9BQU8sS0FBSyxDQUFBO0lBQ2xCLENBQUM7U0FBTSxDQUFDO1FBQ1AsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRO1lBQUUsT0FBTyxLQUFLLENBQUE7O1lBQ3RDLE1BQU0sSUFBSSxLQUFLLENBQUMsaUNBQWlDLENBQUMsQ0FBQTtJQUN4RCxDQUFDO0FBQ0YsQ0FBQztBQW9ERCxNQUFNLFVBQVUsYUFBYSxDQUM1QixLQUF3QyxFQUN4QyxFQUNDLEtBQUssR0FBRyxTQUFTLEVBQ2pCLElBQUksR0FBRyxTQUFTLEVBQ2hCLFNBQVMsR0FBRyxHQUFHLE1BS1osRUFBRTtJQUVOLElBQUksU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLFNBQVMsRUFBRSxDQUFDO1FBQ25DLE9BQU8sVUFBVSxDQUFDLElBQUksRUFBRSxPQUFPLEtBQUssS0FBSyxRQUFRLENBQUMsQ0FBQTtJQUNuRCxDQUFDO1NBQU0sQ0FBQztRQUNQLE9BQU8sVUFBVSxDQUFDLEtBQUssRUFBRSxPQUFPLEtBQUssS0FBSyxRQUFRLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0FBQ0YsQ0FBQyJ9